module.exports = "<p>\n  organization-create works!\n</p>\n"